import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../utils/track";

export const PageTracker = () => {
  const { pathname } = useLocation();
  useEffect(() => { trackPageView(pathname || "/"); }, [pathname]);
  return null;
};

export default PageTracker;
